import Plyr from 'plyr/dist/plyr.polyfilled';

Vue.component('video-player', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            videoPlaying: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        Vue.nextTick(this.setupVideo);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        playVideo() {
            this.video.play();
            this.videoPlaying = true;
        },

        /**
        * Play the intro video
        */
        setupVideo() {
            this.video = new Plyr(this.$el.querySelector('.plyr__video-embed'));

            if (!this.video) {
                return;
            }

            this.video.on('play', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('pause', (event) => {
                this.videoPlaying = false;
            });

            this.video.on('ended', (event) => {
                this.videoPlaying = false;
            });
        },
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/video-player.js